import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, ViewChild, forwardRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';
import { Calendar } from 'primeng/calendar';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';
import * as moment from "moment-timezone";

const noop = () => { };

export const CUSTOM_FMDATEPICKER_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormDatepickerV2Component),
  multi: true
};

@Component({
  selector: 'fm-date-v2',
  templateUrl: 'form-datepicker.component.html',
  styleUrls: ['form-datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CUSTOM_FMDATEPICKER_CONTROL_VALUE_ACCESSOR],
})
export class FormDatepickerV2Component extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) { super(); }
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() defaultDate: Date = new Date();
  @Input() resetBtn: boolean = true;
  @Input() showButtonBar: boolean = true;
  @Input() inline: boolean = false;
  @Input() public disabled: boolean = false;
  @Input('yearRange') yearRange: string = '2000:2035';
  @Output() onSelectValue: EventEmitter<any> = new EventEmitter<any>();
  @Output() onApplyValue: EventEmitter<any> = new EventEmitter<any>();


  tabindex: string;
  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }
  @ViewChild('in') public input: ElementRef;
  @ViewChild(Calendar) calendar: Calendar;

  en: any = {
    firstDayOfWeek: 0,
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  };

  private numOfTabs: number = 0;
  public displayValue: string;
  private innerValue: boolean;
  private initialValue: any;
  private isCalendarOverlayOpen: boolean = false;
  public isOnFocus: boolean = false;
  public values: Date[];
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));
    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
    this.displayValue = this.value ? this.value.format("MMM DD, YYYY") : moment(this.defaultDate).format("MMM DD, YYYY");
  }

  ngOnDestroy() { }

  @HostListener('keypress', ['$event'])
  handleSpace(event: KeyboardEvent) {
    if (event.charCode === 32) {
      const newVal = !this.value;
      this.writeValue(newVal);
      this.onChangeCallback(newVal);
    }
  }

  get value(): any {
    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  onClick(event: any) {
    // event.stopPropagation();
    // this.formEventService.setFocusIn(true);
    // this.formEventService.changeFocus(this.tabindex);
  }

  onFocus(event: Event) {
    this.initialValue = this.value;
    this.isCalendarOverlayOpen = true;
    this.isOnFocus = true;
  }

  //Set touched on blur
  onBlur(event: Event) {
    this.onTouchedCallback();
  }

  onChange(obj: { originalEvent: Event; value: boolean }) {
    if (obj.value !== this.innerValue) {
      this.writeValue(obj.value);
      this.onChangeCallback(obj.value);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      if (moment(value).isValid()) {
        this.values = [];
        this.values.push(value);
        this.displayValue = moment(this.values[0]).format("MMM DD, YYYY");
      } else {
        this.values = undefined;
      }
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onSelect(event: Event) {
    this.writeValue(event);
    this.onChangeCallback(event);
    this.onSelectValue.emit(event);
  }

  onMonthChange(event) {
    if (event.month == (new Date(this.value).getMonth() + 1) && event.year == new Date(this.value).getFullYear()) {
      this.displayValue = moment(this.value).format("MMM DD, YYYY");
    } else {
      this.displayValue = moment(new Date(event.year, event.month - 1)).format("MMMM, YYYY");
    }
  }

  onCancel() {
    this.closeCalendarOverlay();
    this.isOnFocus = false;
    this.writeValue(this.initialValue);
    this.onChangeCallback(this.initialValue);
  }

  onApply() {
    this.initialValue = this.value || this.defaultDate;
    this.closeCalendarOverlay();
    this.isOnFocus = false;
    this.writeValue(this.initialValue);
    this.onChangeCallback(this.initialValue);
    this.onApplyValue.emit(this.initialValue);
  }

  focusOut() {
    if (!this.isCalendarOverlayOpen) {
      this.isOnFocus = false;
    }
  }

  private closeCalendarOverlay() {
    this.isCalendarOverlayOpen = false;
    if (this.calendar) {
      this.calendar.hideOverlay();
    }
  }
}
